import * as constants from './constants';

export const getCustomerIdFromSearch = (search) => {
  const params = new URLSearchParams(search || '');
  return params.get(constants.SSO_CUSTOMER_ID_QUERY_PARAM)?.trim() || '';
};

export const getTenantScopedRoute = (route, customerId = '') => {
  const normalizedCustomerId = String(customerId || '').trim();
  if (!normalizedCustomerId) {
    return route;
  }

  const search = new URLSearchParams({
    [constants.SSO_CUSTOMER_ID_QUERY_PARAM]: normalizedCustomerId,
  });

  return `${route}?${search.toString()}`;
};
